import { SET_IMPERSONATION, CLEAR_IMPERSONATION } from '../actions/ActionTypes';
import ImpersonationService from '../../services/ImpersonationService';

// Initialize state from storage
const initialState = ImpersonationService.getImpersonation() || {
  active: false,
  impersonatedId: null,
  impersonatedName: null
};

const impersonationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IMPERSONATION:
      return {
        ...state,
        active: true,
        impersonatedId: action.payload.impersonatedId,
        impersonatedName: action.payload.impersonatedName
      };
    case CLEAR_IMPERSONATION:
      return {
        ...state,
        active: false,
        impersonatedId: null,
        impersonatedName: null
      };
    default:
      return state;
  }
};

export default impersonationReducer;